import { router } from 'expo-router';
import { ArrowRightIcon, ListChecksIcon, NavigationTile, View } from 'smoothie';

import { useAuthedUser } from '../../../common/providers/AuthedUserProvider';
import { SIDEBAR_CONTENT_MAX_WIDTH } from '../../../common/utils/homeUtils';
import { useRoadmapTabExperience } from '../../../roadmap/hooks/useRoadmapTabExperience';

const GuidanceGoalsTasksTile = () => {
    const user = useAuthedUser();
    const guide = user?.membership?.guide;
    const tabExperience = useRoadmapTabExperience();

    if (!guide) {
        return null;
    }

    if (tabExperience !== 'money_system') {
        return null;
    }

    return (
        <View
            width="100%"
            maxWidth={SIDEBAR_CONTENT_MAX_WIDTH}
            alignSelf="center"
        >
            <NavigationTile
                title="Goals & Tasks"
                description="Review your tasks & to-do's to prepare for upcoming sessions with your Guide"
                backgroundColor="$peach300"
                iconLeft={ListChecksIcon}
                iconRight={ArrowRightIcon}
                onPress={() => {
                    router.navigate('/(app)/roadmap/tasks');
                }}
            />
        </View>
    );
};

export default GuidanceGoalsTasksTile;
